import moment from "moment";
import { STATUS_VIAGEM_LABELS } from "../../utils/Constants";

export const validarViagem = (values, tipo_enum) => {
  const erros = {};

  if (!values.data_agendamento) {
    erros.data_agendamento = "Data da viagem é obrigatória.";
  }

  if (!values.horario_partida) {
    erros.horario_partida = "Horário de partida é obrigatório.";
  }

  if (!values.local_partida) {
    erros.local_partida = "Local de partida é obrigatório.";
  }

  if (!values.tipo_veiculo) {
    erros.tipo_veiculo = "Selecione o tipo de veículo.";
  }

  if (!values.duracao) {
    erros.duracao = "Selecione a duração da viagem.";
  }

  if (!values.cartao_id) {
    erros.cartao_id = "Selecione uma forma de pagamento.";
  }

  if (tipo_enum === "van") {
    if (!values.quantidade_passageiros) {
      erros.quantidade_passageiros = "Informe a quantidade de passageiros.";
    }
  }

  if (tipo_enum === "van" && values.excede_municipio) {
    if (!values.destino_endereco) {
      erros.destino_endereco = "Local de destino é obrigatório para viagens intermunicipais.";
    }
  }

  return erros;
};

export const validarPassageiro = (passageiro) => {
  const erros = {};

  if (!passageiro.nome_completo) {
    erros.nome_completo = "Nome completo é obrigatório.";
  }

  if (!passageiro.documento) {
    erros.documento = "Documento é obrigatório.";
  }

  if (!passageiro.data_nascimento) {
    erros.data_nascimento = "Data de nascimento é obrigatória.";
  }

  if (passageiro.data_nascimento) {
    const nascimento = moment(passageiro.data_nascimento);
    const idade = moment().diff(nascimento, "years");

    if (idade < 18) {
      if (!passageiro.nome_responsavel) {
        erros.nome_responsavel = "Nome do responsável é obrigatório para menores de idade.";
      }

      if (!passageiro.documento_responsavel) {
        erros.documento_responsavel = "Documento do responsável é obrigatório para menores de idade.";
      }
    }
  }

  return erros;
};

export const validarRelacaoPassageiros = (passageiros) => {
  for (let index = 0; index < passageiros.length; index++) {
    const erros = validarPassageiro(passageiros[index]);

    if (Object.keys(erros).length > 0) {
      return `Passageiro ${index + 1}: ${Object.values(erros)[0]}`;
    }
  }

  return null;
};

export const criarPayloadViagem = (form, paradas, passageiros_van) => {
  const payload = {
    data_agendamento: `${form.data_agendamento}T${form.horario_partida}:00`,
    local_partida: form.local_partida,
    latitude: form.latitude,
    longitude: form.longitude,
    tipo_veiculo: form.tipo_veiculo,
    duracao: form.duracao,
    cartao_id: form.cartao_id,
    paradas: paradas
      .filter((parada) => parada.local)
      .map((parada) => ({
        endereco: parada.local,
        horario: parada.horario ? `${form.data_agendamento}T${parada.horario}:00` : null,
        latitude: parada.latitude || null,
        longitude: parada.longitude || null,
      })),
  };

  if (form.passageiro_id) {
    payload.passageiro_id = form.passageiro_id;
  }

  if (form.tipo_veiculo === "van") {
    payload.quantidade_passageiros = parseInt(form.quantidade_passageiros, 10);
    payload.excede_municipio = form.excede_municipio || false;

    if (form.excede_municipio) {
      payload.destino_endereco = form.destino_endereco;
      payload.destino_latitude = form.destino_latitude;
      payload.destino_longitude = form.destino_longitude;
      payload.passageiros = passageiros_van.map((passageiro) => ({
        nome_completo: passageiro.nome_completo,
        documento: passageiro.documento,
        data_nascimento: passageiro.data_nascimento,
        nome_responsavel: passageiro.nome_responsavel || null,
        documento_responsavel: passageiro.documento_responsavel || null,
      }));
    }
  }

  return payload;
};

export const obterStatusInfo = (status) => {
  return STATUS_VIAGEM_LABELS[status] || { label: status, classeKey: "badgeSolicitada" };
};

export const criarPassageiroVazio = () => ({
  nome_completo: "",
  documento: "",
  data_nascimento: "",
  nome_responsavel: "",
  documento_responsavel: "",
});

export const ehVan = (tipo_veiculo) => tipo_veiculo === "van";

export const MAPA_TIPO_VEICULO = {
  NAO_BLINDADO: "executivo",
  BLINDADO: "blindado",
  VAN: "van",
};

export const LABEL_TIPO_VEICULO = {
  NAO_BLINDADO: "Executivo - Não blindado",
  BLINDADO: "Blindado",
  VAN: "Van",
};

export const OPCOES_QUANTIDADE_PASSAGEIROS = Array.from({ length: 8 }, (_, index) => ({
  valor: index + 8,
  label: String(index + 8),
}));

export const OPCOES_FILTRO_STATUS = [
  { valor: "", label: "Todos" },
  { valor: "SOLICITADA", label: "Solicitada" },
  { valor: "ACEITA", label: "Agendada" },
  { valor: "EM_ANDAMENTO", label: "Em andamento" },
  { valor: "FINALIZADA", label: "Finalizada" },
  { valor: "CANCELADA_PASSAGEIRO", label: "Cancelada" },
];
